const protestOptions = [
  {
    title: "Delays Loading",
    id: "lop-delay",
    fields: [
      {
        label: "To",
        type: "text",
        placeholder: "Enter receiver of protest",
      },
      {
        label: "Port",
        type: "text",
        placeholder: "Enter port",
      },
      {
        label: "Voy",
        type: "text",
        placeholder: "Enter voyage number",
      },
      { label: "Date", type: "date" },
      { label: "C/P Date", type: "date" },
      { label: "Vessel arrived", type: "datetime-local" },
      { label: "Notice of Readiness tendered", type: "datetime-local" },
      { label: "Loading commenced", type: "datetime-local" },
      {
        label: "Master",
        type: "text",
      },
    ],
  },
  {
    title: "Delays Discharging",
    id: "lop-delay-discharge",
    fields: [
      {
        label: "To",
        type: "text",
        placeholder: "Enter receiver of protest",
      },
      {
        label: "Port",
        type: "text",
        placeholder: "Enter port",
      },
      {
        label: "Voy",
        type: "text",
        placeholder: "Enter voyage number",
      },
      { label: "Date", type: "date" },
      { label: "C/P Date", type: "date" },
      { label: "Vessel arrived", type: "datetime-local" },
      { label: "Notice of Readiness tendered", type: "datetime-local" },
      { label: "Loading commenced", type: "datetime-local" },
      {
        label: "Master",
        type: "text",
      },
    ],
  },
  {
    title: "Awaiting documents",
    id: "lop-awaiting-doc",
    fields: [
      {
        label: "To",
        type: "text",
        placeholder: "Enter receiver of protest",
      },
      {
        label: "Port",
        type: "text",
        placeholder: "Enter port",
      },
      {
        label: "Voy",
        type: "text",
        placeholder: "Enter voyage number",
      },
      { label: "Date", type: "date" },
      { label: "C/P Date", type: "date" },
      { label: "Hose/Arms disconnected", type: "datetime-local" },
      { label: "Documents onboard", type: "datetime-local" },
      {
        label: "Documents duly signed",
        type: "datetime-local",
      },
      {
        label: "Master",
        type: "text",
      },
    ],
  },
  {
    title: "No Shore Power Connection",
    id: "lop-no-shore-power",
    fields: [
      {
        label: "To",
        type: "text",
        placeholder: "Enter receiver of protest",
      },
      {
        label: "Port",
        type: "text",
        placeholder: "Enter port",
      },
      {
        label: "Voy",
        type: "text",
        placeholder: "Enter voyage number",
      },
      { label: "Date", type: "date" },
      { label: "C/P Date", type: "date" },
      { label: "Hose/Arms disconnected", type: "datetime-local" },
      { label: "Documents onboard", type: "datetime-local" },
      {
        label: "Documents duly signed",
        type: "datetime-local",
      },
      {
        label: "Master",
        type: "text",
      },
    ],
  },
  {
    title: "Protest for discrepancy B/L - Ship figures",
    id: "lop-discrepancy",
    fields: [
      {
        label: "To",
        type: "text",
        placeholder: "Enter receiver of protest",
      },
      {
        label: "Port",
        type: "text",
        placeholder: "Enter port",
      },
      {
        label: "Voy",
        type: "text",
        placeholder: "Enter voyage number",
      },
      { label: "Date", type: "date" },
      { label: "C/P Date", type: "date" },

      { label: "Discharge port", type: "text" },
      { label: "B/L Date", type: "date" },

      { label: "Grade", type: "text" },
      { label: "B/L Figure", type: "number" },

      { label: "Ship Figure", type: "number", step: 0.01 },

      {
        label: "Master",
        type: "text",
      },
    ],
  },
  {
    title: "Slow loading rate",
    id: "lop-slow-loading",
    fields: [
      {
        label: "To",
        type: "text",
        placeholder: "Enter receiver of protest",
      },
      {
        label: "Port",
        type: "text",
        placeholder: "Enter port",
      },
      {
        label: "Voy",
        type: "text",
        placeholder: "Enter voyage number",
      },
      { label: "Date", type: "date" },
      { label: "C/P Date", type: "date" },
      { label: "Ship loading", type: "text" },
      { label: "Avg loading", type: "text" },

      {
        label: "Master",
        type: "text",
      },
    ],
  },
  {
    title: "Restricted Discharging Capacity",
    id: "lop-restricted-discharging",
    fields: [
      {
        label: "To",
        type: "text",
        placeholder: "Enter receiver of protest",
      },
      {
        label: "Port",
        type: "text",
        placeholder: "Enter port",
      },
      {
        label: "Voy",
        type: "text",
        placeholder: "Enter voyage number",
      },
      { label: "Date", type: "date" },
      { label: "C/P Date", type: "date" },
      { label: "Manifolds", type: "text" },
      { label: "Pump capacity", type: "text" },
      { label: "Cargo hose", type: "text" },
      { label: "Restricted pump capacity", type: "text" },

      {
        label: "Master",
        type: "text",
      },
    ],
  },
  {
    title: "Shore stops",
    id: "lop-terminal-stops",
    fields: [
      {
        label: "To",
        type: "text",
        placeholder: "Enter receiver of protest",
      },
      {
        label: "Port",
        type: "text",
        placeholder: "Enter port",
      },
      {
        label: "Voy",
        type: "text",
        placeholder: "Enter voyage number",
      },
      { label: "Date", type: "date" },
      { label: "C/P Date", type: "date" },
      { label: "Shore stops", type: "shorestop" },
      {
        label: "Master",
        type: "text",
      },
    ],
  },
  {
    title: "General",
    id: "lop-general",
    fields: [
      {
        label: "To",
        type: "text",
        placeholder: "Enter receiver of protest",
      },
      {
        label: "Port",
        type: "text",
        placeholder: "Enter port",
      },
      {
        label: "Voy",
        type: "text",
        placeholder: "Enter voyage number",
      },
      {
        label: "General Protest Reason",
        type: "text",
        placeholder: "Enter protest reason",
        rows: 4,
      },
      { label: "Date", type: "date" },
      { label: "C/P Date", type: "date" },
      {
        label: "Master",
        type: "text",
      },
    ],
  },
  {
    title: "Short Loading",
    id: "lop-short-loading",
    fields: [
      {
        label: "To",
        type: "text",
        placeholder: "Enter receiver of protest",
      },
      {
        label: "Port",
        type: "text",
        placeholder: "Enter port",
      },
      {
        label: "Voy",
        type: "text",
        placeholder: "Enter voyage number",
      },
      { label: "Date", type: "date" },
      { label: "C/P Date", type: "date" },

      { label: "Grade", type: "text" },
      { label: "Required quantity", type: "number" },
      { label: "B/L Figure", type: "number" },
      { label: "Ship Figure", type: "number" },
      { label: "Deadweight", type: "number" },

      { label: "Bunkers", type: "number" },
      { label: "FW", type: "number" },
      { label: "Stores", type: "number" },
      { label: "Cargo Capacity", type: "number" },

      {
        label: "Master",
        type: "text",
      },
    ],
  },
  {
    title: "Missing Quality Certification",
    id: "lop-quality-cert",
    fields: [
      {
        label: "To",
        type: "text",
        placeholder: "Enter receiver of protest",
      },
      {
        label: "Port",
        type: "text",
        placeholder: "Enter port",
      },
      {
        label: "Voy",
        type: "text",
        placeholder: "Enter voyage number",
      },
      { label: "Date", type: "date" },
      { label: "C/P Date", type: "date" },
      {
        label: "Master",
        type: "text",
      },
    ],
  },
  {
    title: "No Samples for the Vessel's own use",
    id: "lop-no-vessel-sample",
    fields: [
      {
        label: "To",
        type: "text",
        placeholder: "Enter receiver of protest",
      },
      {
        label: "Port",
        type: "text",
        placeholder: "Enter port",
      },
      {
        label: "Voy",
        type: "text",
        placeholder: "Enter voyage number",
      },
      { label: "Date", type: "date" },
      { label: "C/P Date", type: "date" },
      {
        label: "Master",
        type: "text",
      },
    ],
  },
];

export default protestOptions;
